import React from "react";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { Link } from "react-router";
import { RaisedButton } from "material-ui";
import { Table } from "reactable";

import connectToStores from "alt-utils/lib/connectToStores";
import KioskActions from "../actions/KioskActions";
import KioskStore from "../stores/KioskStore";

class Kiosks extends React.Component {
  constructor(props) {
    super(props);
    this._makeRowForKiosk = this._makeRowForKiosk.bind(this);
  }

  static getStores() {
    return [KioskStore];
  }

  static getPropsFromStores() {
    return {
      kiosks: KioskStore.getState().kiosks
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  _makeRowForKiosk(kiosk) {
    return {
      Name: kiosk.name,
      Code: kiosk.code,
      Printer: kiosk.printer,
      Actions: (
        <div>
          <Link
            to={`/event_buckets/${this.props.params.eventBucketId}/kiosks/${kiosk.id}`}
          >
            Edit kiosk
          </Link>
        </div>
      )
    };
  }

  componentDidMount() {
    KioskActions.fetchAllForBucket(this.props.params.eventBucketId);
  }

  render() {
    let styles = this.getStyles(),
      bucket = this.props.params.eventBucketId,
      kiosks = values(pick(this.props.kiosks, c => c.event_bucket === bucket)),
      rows = kiosks.map(this._makeRowForKiosk);

    return (
      <div>
        <Table
          className="bordered striped responsive-table"
          data={rows}
          sortable={true}
          columns={["Name", "Code", "Printer", "Actions"]}
          filterable={["Name", "Code"]}
          filterPlaceholder="Type to filter..."
        />
        <div style={{ marginTop: 20 }}>
          <RaisedButton
            label="Create new kiosk"
            primary={true}
            onTouchTap={() =>
              this.context.router.push(
                `/event_buckets/${this.props.params.eventBucketId}/kiosks/new`
              )
            }
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(Kiosks);



// WEBPACK FOOTER //
// ./src/app/components/kiosks.jsx